export default __webpack_public_path__ + "static/media/logout.894fb0ef.svg";